import config from 'react-global-configuration';
export var menuGetTree = function menuGetTree(menuId) {
  return function (dispatch, getState) {
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    var credentials = getState().getIn(['ui', 'fetch', 'credentials', 'menu']) || getState().getIn(['ui', 'fetch', 'credentials', 'content'], 'include');
    var headers = getState().getIn(['ui', 'fetch', 'headers', 'content']);
    fetch("".concat(PATH, "/entity/menu/").concat(menuId, "/tree?_format=json"), {
      credentials: credentials,
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      dispatch(menuGetTreeLoaded(menuId, response));
    }).catch(function () {
      // Do nothing.
    });
  };
};
export var MENU_GET_TREE_LOADED = 'MENU_GET_TREE_LOADED';
export function menuGetTreeLoaded(menuId, data) {
  return {
    type: MENU_GET_TREE_LOADED,
    menuId: menuId,
    data: data
  };
}